import React from "react";
import styles from "./NextSection.module.scss";
import cx from "classnames";

export default function NextSection({
  children,
  className,
  type = "light",
}: {
  children: string | React.ReactNode;
  type?: "light" | "dark";
  className?: string | { [key: string]: string };
}) {
  return (
    <div
      className={cx(
        {
          [styles.separator]: type === "light",
          [styles.darkSeparator]: type === "dark",
        },
        className
      )}
    >
      {children}
    </div>
  );
}
